import { render, staticRenderFns } from "./ResetLink.auth.vue?vue&type=template&id=e1ac0946&scoped=true&"
import script from "./ResetLink.auth.vue?vue&type=script&lang=js&"
export * from "./ResetLink.auth.vue?vue&type=script&lang=js&"
import style0 from "./ResetLink.auth.vue?vue&type=style&index=0&id=e1ac0946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ac0946",
  null
  
)

export default component.exports